(() => {
    // Wrap all numbers in counter-enabled sections in a span and give them a class
    document.querySelectorAll('.counter:not(.cms-section), .counter:not(.cms-section) *').forEach((element) => {
        Array.from(element.childNodes)
            .forEach((el, i) => {
                if(el.nodeType === Node.TEXT_NODE && /\d/.test(el.nodeValue)) {
                    var text = el.textContent;
                    var s = document.createElement('span');
    
                    s.className = 'count';
                    s.textContent = text;
                    el.parentElement.insertBefore(s, el.parentElement.childNodes[i]);
                    el.remove();
                }
        });
    });

    // Count up all numbers from 0 to the entered number
    // Only trigger the first time the number enters the viewport
    const elements = document.querySelectorAll('.count');
    let exec = new Array(elements.length);

    function callbackFunc() {
        for (var i = 0; i < elements.length; i++) {
            if (!exec[i]) {
                if (App.Layout.isElementInViewport(elements[i])) {
                    App.Layout.count(elements[i], 4000);

                    exec[i] = true;
                }
            }
        }
    }

    window.addEventListener('load', callbackFunc);
    window.addEventListener('scroll', callbackFunc, {passive: true});
})();
